<p-dataView #dv [value]="tracks" layout="list">
    <ng-template #header>
        <!-- big screen -->
        <div class="hidden justify-end xl:flex lg:flex md:flex">
            <p-selectButton [options]="statusOptions" [(ngModel)]="currentStatusFilter" [multiple]="false"
                optionLabel="name">
                <ng-template #item let-statusItem>
                    <div>
                        <div>{{ statusItem.name }} </div>                  
                        <div class="status-count ">{{ tracks | statusCountFilter:statusItem.value }}</div>
                    </div>
                </ng-template>
            </p-selectButton>
        </div>
        <!-- small screen-->
        <div class="flex justify-end xl:hidden lg:hidden md:hidden">
            <p-select [options]="statusOptions" [(ngModel)]="currentStatusFilter" (onChange)="onFilterChange($event)" optionLabel="name" 
            [overlayOptions]="{mode: 'overlay'}">
                <ng-template #selectedItem>
                    <div class="flex items-center gap-2" *ngIf="currentStatusFilter">
                        <div>{{ currentStatusFilter.name }}</div>
                        <div class="status-count">{{ tracks | statusCountFilter:currentStatusFilter.value }}</div>
                    </div>
                </ng-template>
                <ng-template #item let-statusItem>
                    @if(statusItem.visible) {
                    <div class="flex items-center gap-2">
                        <div>{{ statusItem.name }}</div>
                        <div class="status-count flex-wrap">{{ tracks | statusCountFilter:statusItem.value }}</div>
                    </div>
                    }
                </ng-template>
            </p-select>
        </div>
    </ng-template>
    <ng-template #list let-track let-tracks>
        <div class="grid-nogutter grid grid-cols-12 gap-4 xl:pl-20 xl:pr-20 md:pl-20 md:pr-20 sm:pl-6 sm:pr-6">

            @for(trackData of tracks | statusFilter:currentStatusFilter.value; track trackData.id; let first = $first) {
            <div class="col-span-12">
                <div class="flex flex-row items-start p-6 gap-6"
                    [ngClass]="{ 'border-t-1 border-gray-300 surface-border': !first }">


                    <img class="shadow-sm block xl:block mx-auto rounded-border" width="40" [src]="'assets/img/box.svg'"
                        (click)="showHistoryWnd(trackData)" />

                    <div class="flex flex-row justify-between items-start flex-1 gap-6">
                        <div class="flex flex-col items-start gap-1" (click)="showHistoryWnd(trackData)">
                            <div>
                                <div class="text-xl font-bold">
                                    {{ trackData.tracknum }}
                                </div>
                                <div class="font-bold text-base text-gray-600">
                                    {{ trackData.title }}
                                </div>
                            </div>

                            <div class="">{{ trackData.dt | date: 'dd.MM.yyyy HH:mm' }}</div>
                            <!-- <p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating> -->
                            @if(trackData.weight){
                            <div class="flex sm:hidden gap-4">
                                <span class="flex gap-2">
                                    <span class="font-semibold">Вес:</span>
                                </span>
                                <span class="font-semibold">{{ trackData.weight + 'гр.'}}</span>
                            </div>
                            }
                            <div class="flex gap-4">
                                <span class="flex gap-2">
                                    <span class="font-semibold">Статус:</span>
                                </span>
                                <div class="status-value"
                                    [ngStyle]="{'background-color': getStatusColor(trackData.status_id)}">
                                    <b>{{ trackData.status ?? 'data error' }}</b>
                                </div>
                            </div>
                        </div>
                        <div class="flex sm:flex-col items-center sm:items-end gap-4 sm:gap-2">
                            @if(trackData.weight){
                            <span class="hidden sm:flex text-2xl font-semibold">{{ trackData.weight + 'гр.'}}</span>
                            }
                            <p-button icon="pi pi-trash" severity="danger" [text]="true" class="self-end"
                                pTooltip="Удалить трек" (click)="deleteTrack(trackData.id)"></p-button>
                        </div>

                    </div>
                </div>
            </div>
            }@empty {
            <div class="col-span-12 flex justify-center flex-wrap">
                <p class="text-2xl">Нет данных</p>
            </div>
            }
        </div>
    </ng-template>

</p-dataView>

<div class="float">
    <p-button [outlined]="true" [rounded]="true" icon="fa fa-plus" severity="danger" pTooltip="Добавить трек"
        (click)="showAddTrackWnd()">
    </p-button>
</div>

<p-sidebar [(visible)]="historyWndVisible" position="right" (onHide)="clearCurrentTrack()" class="detailsSidebar">
    <h3>История статусов</h3>
    <div class="pt-8">
        <p-timeline [value]="trackHistoryEvents()" styleClass="customized-timeline">
            <ng-template #content let-event>
                <small class="p-text-secondary">{{ event.date | date: 'dd.MM.yyyy HH:mm' }}</small>
            </ng-template>
            <ng-template #opposite let-event>
                {{ event.status }}
            </ng-template>
        </p-timeline>
    </div>
</p-sidebar>

<app-add-track [(visible)]="addTrackWndVisible" (onHide)="loadTracksData()" [trackData]="currentTrack"></app-add-track>